var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cart-btn bg-none",attrs:{"type":"button"},on:{"click":function($event){return _vm.cartListsOpen()}}},[_c('ShoppingCart'),(_vm.quantity != 0)?_c('span',{staticClass:"rounded-circle bg-color-red text-white p-1 font-s-12"},[_vm._v(" "+_vm._s(_vm.quantity))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }